import { responsive, spacing, Theme, ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const visibilities: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: spacing(4),
  alignItems: 'start',

  '.visibilities__list': {
    display: 'grid',
    gridTemplateColumns: responsive({
      0: 'repeat(1, 1fr)',
      3: 'repeat(2, 1fr)',
      4: 'repeat(2, 1fr)',
      6: 'repeat(3, 1fr)',
    }),
    flexWrap: 'wrap',
    gap: spacing(3),
    listStyle: 'none',
    padding: 0,
    m: spacing(0),
    maxHeight: '50vh',
    overflow: 'auto',
    width: '100%',

    li: {
      p: spacing(3),
      border: '1px solid',
      borderColor: 'muted',
      display: 'flex',
      flexWrap: 'nowrap',
      gap: spacing(3),
      alignItems: 'center',
      justifyContent: 'space-between',

      '& label': {
        wordBreak: 'break-word',
        whiteSpace: 'nowrap',
        fontWeight: 'bold',

        span: {
          fontWeight: 'bold',
        },
      },

      span: {
        wordBreak: 'break-word',
        textAlign: 'right',
        justifyContent: 'end',
      },

      '& label, span': {
        display: 'flex',
        wrap: 'nowrap',
        gap: spacing(3),
        alignItems: 'center',
      },

      '&:last-of-type': {},
    },

    p: {
      margin: 0,
      mt: spacing(3),
    },

    '.visibilities__list__item': {
      p: spacing(3),
    },
  },

  '.visibilities__gridView': {
    border: '1px solid',
    borderColor: 'muted',
    maxHeight: '50vh',
    overflow: 'auto',
    width: '100%',

    '.iconInput': {
      width: '100%',
    },

    table: {
      border: 'none',
      borderCollapse: 'collapse',
      width: '100%',
      bg: 'white',

      'thead, tfoot': {
        position: 'sticky',
      },
      thead: {
        insetBlockStart: 0,
        zIndex: 1,
        top: '-2px',

        borderBottom: '1px solid',
        borderBottomColor: 'muted',
      },

      'th, td': {
        textAlign: 'center',
        p: spacing(3),

        '& label': {
          alignItems: 'center',
        },

        ':nth-of-type(1)': {
          width: 'min-content',
        },

        ':nth-of-type(2)': {
          width: 'min-content',
        },

        ':nth-of-type(3)': {
          textAlign: 'left',
          width: '100%',
        },

        ':nth-of-type(4)': {
          textAlign: 'center',
          width: 'max-content',

          '& label': {
            justifyContent: 'center',
          },
        },
      },

      tfoot: {
        insetBlockEnd: 0,
        bg: 'white',
        td: { '&:last-of-type': { textAlign: 'right' } },
        bottom: '-2px',
      },

      th: {
        bg: 'white',
        color: 'primary',
        p: spacing(3),
        width: 'min-content',
        whiteSpace: 'nowrap',
      },

      'tr:nth-of-type(even)': {
        bg(theme: Theme) {
          return theme.palette.lightenColor('lightBlue', 8);
        },

        td: {
          borderTop: '1px solid',
          borderBottom: '1px solid',
          borderColor(theme: Theme) {
            return theme.palette.darkenColor('lightBlue', 0);
          },
        },
      },
    },
  },
  /* PREPEND HERE */
};

export default visibilities;
